'use strict';

angular.module('cimerFrontEndApp').controller('ReportingCtrl', ['$scope', '$routeParams', 'ReportService', 'Session', '$q', '$location', 'ApiUrl', '$http', 'authorized',
    function ($scope, $routeParams, ReportService, Session, $q, $location, ApiUrl, $http, authorized) {
        // Route away if the user isn't authorized to view this report
        if (!authorized) {
            $location.url('/');
            return;
        }

        var sessionObject = Session.getSessionObject();
        if (!sessionObject.isAuthenticated) {
            $location.url('/');
            return;
        }

        //pull values from the url query parameters and grab survey report data from server
        $scope.surveyID = $routeParams.id;

        $scope.isBase = false;
        if ($routeParams.isBase) {
            $scope.isBase = $routeParams.isBase;
        }


        $scope.sections = [];
        $scope.compositeScores = [];
        $scope.summary = {};
        $scope.dataRendering = false;
        $scope.dataLoading = true;

        $scope.input = {
            filter: null
        };

        $scope.filterSectionForExcludedBaseQuestions = function () {

            // item should be a survey Section
            return function (item) {
                
                // We only want to filter out an entire section if all of the questions are excluded
                
                // For every QuestionPrompt in the section
                for (var i = 0; i < item.QuestionPrompts.length; i++) {
                    // Radio or Text question
                    if (item.QuestionPrompts[i].hasOwnProperty('ExcludeFromReports')) {

                        // This question is not excluded, therefore the section can't be hidden 
                        if (item.QuestionPrompts[i].ExcludeFromReports !== true) {
                            return true;
                        }

                        // Matrix question
                    } else {
                        for (var j = 0; j < item.QuestionPrompts[i].Questions.length; j++) {

                            // This question is not excluded, therefore the section can't be hidden
                            if (item.QuestionPrompts[i].Questions[j].ExcludeFromReports !== true) {
                                return true;
                            }
                        }
                    }

                }

                return false;
            };

        };

        $scope.filterQuestionForExcludedBaseQuestions = function () {

            // item should be a question or matrix of questions
            return function (item) {

                // If a Radio or Text question
                if (item.hasOwnProperty('ExcludeFromReports')) {
                    if (item.ExcludeFromReports === true) {
                        return false;
                    }
                } else { // Is a matrix question
                    for (var i = 0; i < item.Questions.length; i++) {
                        if (item.Questions[i].ExcludeFromReports === true) {
                            return false;
                        }
                    }
                }

                return true;
            };
        };

        $scope.$on('ngRepeatSectionFinished', function (ngRepeatSectionFinishedEvent) {
            $scope.dataRendering = false;
        });

        var _uploadApiUrl = ApiUrl.url('/Upload/');

        $http.get(_uploadApiUrl + 'UserRelationshipOptions')
            .then(function (response) {
                $scope.UserRelationshipOptions = response.data;
            });

        $scope.setup = function () {
            $scope.dataLoading = true;

            var prom = [];
            prom.push(ReportService.getSurveyReport($scope.surveyID, $scope.input.filter, $scope.isBase));
            prom.push(ReportService.getSurveySummary($scope.surveyID, $scope.isBase, $scope.input.filter));
            $q.all(prom).then(function (data) {
                $scope.sections = data[0].sections;
                $scope.compositeScores = data[0].compositeScores;
                $scope.summary = data[1];
                if ($scope.sections.length > 0) {
                    $scope.dataRendering = true;
                }
                $scope.dataLoading = false;
            });
        };

        $scope.setup();

        $scope.$watch('input.filter',
            function (filter) {
                //if data is loading, this is the initial setup
                if (!$scope.dataLoading) {
                    $scope.setup();
                }
            });

        //clear old report details
        ReportService.clearReportQuestionDetails();

        $scope.displayQuestionDetails = function (question) {

            //save question to reporting service
            ReportService.setReportQuestionDetails(question, $scope.surveyID, $scope.summary);
            //then route to next page
            $location.url('/reportDetails');
        };

        $scope.percentage = function (num) {
            return (num * 100).toFixed(2) + "%";
        };

        $scope.renderHtml = function (html_code) {
            return html_code;
        };

    }]);

angular.module('cimerFrontEndApp').controller('ReportQuestionDetailCtrl', ['$scope', 'ReportService', 'Session', '$location', function ($scope, ReportService, Session, $location) {
    var sessionObject = Session.getSessionObject();
    if (!sessionObject.isAuthenticated) {
        $location.url('/');
        return;
    }

    var _findMode = function (q) {

        var val = 0,
            tempMode = '',
            mode = [];

        for (var i = 0; i < q.QuestionScale.length; i++) {
            if (q.QuestionScale[i].Count > val) {
                val = q.QuestionScale[i].Count;
            }
        }

        //once we've found the max value, assign all question answers to mode
        for (var j = 0; j < q.QuestionScale.length; j++) {
            if (q.QuestionScale[j].Count === val) {
                tempMode = q.QuestionScale[j].AnswerNumber + ':' + q.QuestionScale[j].AnswerText;
                mode.push(tempMode);
            }
        }

        q.mode = mode;
        q.modeCount = val;

        return q;
    };

    var details = ReportService.getReportQuestionDetails();
    $scope.reportId = details.reportId;
    $scope.summary = details.summary;
    $scope.question = _findMode(details.question);

}]);


angular.module('cimerFrontEndApp').controller('dataSharingAgreementCtrl', ['$scope', '$uibModalInstance', 'InstitutionService',
    function ($scope, $uibModalInstance, InstitutionService) {
        'use strict';

        //$scope.grant = grant;
        //Get the list of Institutions 
        InstitutionService.getAllInstitutions().then(function (results) {
            $scope.Institutions = results.data;
        }, function () {
            $scope.Institutions = null;
        });

        $scope.formSubmitted = false;
        $scope.invalidIrbNumber = false;

        $scope.irbNumber = '';
        $scope.selectedInstitution = '';

        var response = {
            radioSelection: $scope.dataSharingRadio,
            irbNumber: $scope.irbNumber === '' ? null : $scope.irbNumber,
            selectedInstitution: $scope.selectedInstitution === '' ? null : $scope.selectedInstitution,
            grant: $scope.grant
        };

        $scope.accept = function () {

            if ($scope.dataSharingRadio === 'agree') {

                response.radioSelection = $scope.dataSharingRadio;
                response.irbNumber = null;
                response.selectedInstitution = null;

                $uibModalInstance.close(response);

                return;
            }

            if ($scope.dataSharingRadio === 'doNotAgree') {
                // Shouldn't get here since Accept button isn't clickable
                return;
            }

            // We need to check some additional fields for the Does Not Apply option

            $scope.formSubmitted = true;

            // If the required error isn't triggered on IRB Number, but the value isn't an integer
            if (!$scope.doesNotApplyForm.irbNumber.$error.required && (new RegExp('\\D').test($scope.irbNumber) || isNaN(parseInt($scope.irbNumber)))) {
                $scope.invalidIrbNumber = true;
                return;
            } else {
                $scope.invalidIrbNumber = false;
            }

            // If the form is valid
            if (!$scope.doesNotApplyForm.$invalid) {
                response.radioSelection = $scope.dataSharingRadio;
                response.irbNumber = $scope.irbNumber === '' ? null : $scope.irbNumber;
                response.selectedInstitution = $scope.selectedInstitution === '' ? null : $scope.selectedInstitution;

                $uibModalInstance.close(response);
            }

        };

        $scope.dataSharingRadio = "agree";

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }]);


angular.module('cimerFrontEndApp')
    .directive('onFinishSectionRender', ['$timeout',
        function ($timeout) {
            return {
                restrict: 'A',
                link: function (scope, element, attr) {
                    if (scope.$last === true) {

                        $timeout(function () {
                            scope.$emit('ngRepeatSectionFinished');
                        });
                    }
                }
            };
        }]);
